
define('hbs!app/filters/controls/AddFilterControl.hbs',['hbs','handlebars'], function(hbs, Handlebars){var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"filter-operator\">Click to define a filter&hellip;</span>";
},"useData":true});Handlebars.registerPartial('app/filters/controls/AddFilterControl.hbs', t);return t;});
